import { useEffect } from "react";

export default function useLineScrollAnimation() {
  useEffect(() => {
    let observer;

    const splitLines = () => {
      const elements = document.querySelectorAll(".split-lines");

      elements.forEach((el) => {
        if (el.dataset.split === "true") return;

        const html = el.innerHTML;

        // Split only by <br> or just the text content if no <br>
        const lines = html.includes("<br") 
          ? html.replace(/<br\s*\/?>/gi, "|||").split("|||")
          : [html.trim()];
          
        const filteredLines = lines.map((l) => l.trim()).filter(Boolean);

        el.innerHTML = filteredLines
          .map(
            (line, i) => `
              <span class="line">
                <span style="transition-delay:${i * 0.15}s">${line}</span>
              </span>
            `,
          )
          .join("");

        el.dataset.split = "true";
      });

      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("animate");
            } else {
              // Optional: remove class when out of view
              // entry.target.classList.remove("animate");
            }
          });
        },
        {
          threshold: 0.2, // Lower threshold for better UX
        },
      );

      // Observe both split-lines and regular reveal animations
      document
        .querySelectorAll(".split-lines, .reveal-up, .fade-up-anim")
        .forEach((el) => observer.observe(el));
    };

    // ⏱️ WAIT until DOM is painted
    requestAnimationFrame(() => {
      requestAnimationFrame(splitLines);
    });

    return () => observer && observer.disconnect();
  }, []);
}
